"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountAccessAuthGuardService = void 0;
const router_1 = require("@angular/router");
const of_1 = require("rxjs/internal/observable/of");
const operators_1 = require("rxjs/operators");
const account_service_1 = require("./account.service");
/**
 * Account Access Auth Guard Service
 *
 * Checks if the user has the access to activate component
 */
class AccountAccessAuthGuardService {
    constructor(router, accountService) {
        this.router = router;
        this.accountService = accountService;
    }
    canActivate(route, state) {
        // dynamically handling the route on the basis of allowed roles
        const allowedRoles = route.data['allowedRoles'];
        const allowedCustomers = route.data['allowedCustomers'];
        return this.accountService.getAccountDetails(true).pipe(operators_1.map((res) => {
            this.isBusinessAccount = res.businessAccount;
            this.isPrepaid = res.advancePayAccount;
            if (res && ((res.accountHotlined && !(allowedRoles === null || allowedRoles === void 0 ? void 0 : allowedRoles.includes('HOTLINED')))
                || (res.prospectProfile && !(allowedRoles === null || allowedRoles === void 0 ? void 0 : allowedRoles.includes('NON-PRIMARY')))
                || (res.profileType === 'SECONDARY') && !(allowedRoles === null || allowedRoles === void 0 ? void 0 : allowedRoles.includes('SECONDARY')))
                || (res.advancePayAccount && res.amountToUnsuspend > 0.00 && res.profileType !== 'SECONDARY')) {
                // redirect to dashboard instead of returning false to avoid displaying blank page
                // if user is being redirected to the restricted route as relayState after login
                this.redirectToDashboard();
            }
            else if (!this.isPrepaid && (allowedCustomers === null || allowedCustomers === void 0 ? void 0 : allowedCustomers.includes('PREPAID'))) {
                this.redirectToDashboard();
            }
            else {
                return true;
            }
        }), operators_1.catchError((err) => {
            this.router.navigate(['/wireless']);
            return of_1.of(false);
        }));
    }
    redirectToDashboard() {
        if (this.isBusinessAccount) {
            this.router.navigate(['/business']);
        }
        else if (this.isPrepaid) {
            this.router.navigate(['/prepaid']);
        }
        else {
            this.router.navigate(['/wireless']);
        }
    }
}
exports.AccountAccessAuthGuardService = AccountAccessAuthGuardService;
//# sourceMappingURL=accountaccessauth.service.js.map